import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { CabeceraVAMModule } from "../../../components/common/cabeceraVAMTitulares/cabecera-vam-titulares.module";
import { RenunciaBeneficioSeguroComponent } from "./renuncia-beneficio-seguro.component";
import { RenunciaBeneficioSeguroService } from "./renuncia-beneficio-seguro.service";

@NgModule({
    declarations: [RenunciaBeneficioSeguroComponent],
    imports: [BrowserModule, HttpModule,
        FormsModule,        
        BrowserAnimationsModule,        
        DataTableModule,
        CabeceraVAMModule],
    providers: [RenunciaBeneficioSeguroService]
})

export class RenunciaBeneficioSeguroModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.module.ts